// Radha — sparkline for a stat tile's trend (dataviz skill anatomy spec: thin
// 2px line in the de-emphasis hue, the current/latest point picked out in the
// accent). Only ever fed real stored history — never a fabricated trend.
import React from "react";

export function Sparkline({ values, width = 96, height = 28, accent = "var(--accent-purple)" }: {
  values: number[]; width?: number; height?: number; accent?: string;
}) {
  if (values.length < 2) return null;
  const min = Math.min(...values), max = Math.max(...values);
  const span = max - min || 1;
  const pad = 3;
  const pts = values.map((v, i) => {
    const x = pad + (i / (values.length - 1)) * (width - pad * 2);
    const y = height - pad - ((v - min) / span) * (height - pad * 2);
    return [x, y] as const;
  });
  const path = pts.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const last = pts[pts.length - 1];

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Trend">
      <path d={path} fill="none" stroke="var(--fg-faint)" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={last[0]} cy={last[1]} r={2.5} fill={accent} />
    </svg>
  );
}
